import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * A language code (e.g. `fr`) named in the viewer's own language, for the languages that don't
 * carry a translation key of their own (see `runnerLanguages` in `consts.js`).
 *
 * `Intl.DisplayNames` is expensive enough to construct that building it fresh on every render is
 * noticeably slow, so each caller gets one memoized against `i18n.language`, rebuilt only when
 * the viewer's language actually changes.
 *
 * @returns {Intl.DisplayNames}
 */
const useLanguageDisplayNames = () => {
  const { i18n } = useTranslation();

  return useMemo(
    () => new Intl.DisplayNames([i18n.language], { type: 'language' }),
    [i18n.language],
  );
};
export default useLanguageDisplayNames;
